
import { defineComponent, reactive, toRefs } from 'vue'
import rem from '@/utils/rem.js'
import request from '@/utils/hbRequest.js'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { Toast } from 'vant'
// 设计稿750=1:1    1rem = 100px
rem(750, 750)
export default defineComponent({
  name: 'UserLogin',
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const state = reactive({
      form: {
        code: '',
        insuCode: null,
        name: '',
        phone: ''
      },
      banner: ''
    })
    const userId = localStorage.getItem('userId')
    if (userId) {
      store.commit('setUserId', userId)
      router.push({ path: '/huBeiService/serviceInfo' })
    }
    // 取缓存中的用户信息
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      state.form = Object.assign(state.form, JSON.parse(userInfo))
    }
    state.form.insuCode = route.query.insuCode || ''

    const getBanner = async () => {
      const res = await request.get(
        `/spread/insu/${state.form.insuCode}/detail`
      )
      if (res.code !== 0) {
        return Toast(res.message)
      }
      state.banner = res.data.url
    }

    getBanner()

    const validatorTel = (val) => {
      const reg = /^[1][3,4,5,7,8][0-9]{9}$/
      const flag = reg.test(val)
      if (!flag) {
        return '请输入正确的手机号'
      }
      return true
    }
    const onSubmit = async () => {
      const res = await request.post('/spread/salesman/login', state.form)
      if (res.code !== 0) {
        return Toast(res.message)
      }
      store.commit('setUserId', res.data.id)
      localStorage.setItem('userInfo', JSON.stringify(state.form))
      router.push({ path: '/huBeiService/serviceInfo' })
    }
    return {
      ...toRefs(state),
      validatorTel,
      onSubmit
    }
  }
})
